import "./styles.scss";
import { gsap } from "gsap";
import { isTouch } from "../services/helpers";
class EmbertStartAnimation {
  constructor() {
    this.DOM = { wrapper: document.getElementById("em-starter") };
    this.DOM.leftRevealer = this.DOM.wrapper.querySelector(".left-mask .revealer");
    this.DOM.rightRevealer = this.DOM.wrapper.querySelector(".right-mask .revealer");
    this.prepareDOM();
    this.mouseEventsCreated = false;
    this.isAnimating = false;
    this.animate();
  }
  prepareDOM = () => {
    gsap.set(this.DOM.leftRevealer, { xPercent: 80, autoAlpha: 1 });
    gsap.set(this.DOM.rightRevealer, { xPercent: -80, autoAlpha: 1 });
    console.log("f prepareDOM");
  };
  animate = () => {
    return gsap
      .timeline({
        onStart: () => (this.isAnimating = true),
        onComplete: () => {
          this.createEvents();
          this.isAnimating = false;
        },

        defaults: { duration: 1 },
      })
      .to(this.DOM.leftRevealer, { xPercent: window.innerWidth > 768 ? 20 : 14 })
      .to(this.DOM.rightRevealer, { xPercent: window.innerWidth > 768 ? 0 : 8 }, "-=.75");
  };
  createEvents = () => {
    window.addEventListener("resize", () => {
      setTimeout(() => {
        if (this.isAnimating) {
          return;
        }
        this.prepareDOM();
        this.animate();
      }, 1500);
    });
    if (!this.mouseEventsCreated && !isTouch()) {
      this.DOM.leftRevealer.addEventListener(
        "mouseenter",
        () => !this.isAnimating && gsap.to(this.DOM.leftRevealer, { xPercent: 10 })
      );
      this.DOM.leftRevealer.addEventListener(
        "mouseleave",
        () => !this.isAnimating && gsap.to(this.DOM.leftRevealer, { xPercent: 20 })
      );
      this.DOM.rightRevealer.addEventListener(
        "mouseenter",
        () => !this.isAnimating && gsap.to(this.DOM.rightRevealer, { xPercent: 10 })
      );
      this.DOM.rightRevealer.addEventListener(
        "mouseleave",
        () => !this.isAnimating && gsap.to(this.DOM.rightRevealer, { xPercent: 0 })
      );
      this.mouseEventsCreated = true;
    }
  };
}
const starter = new EmbertStartAnimation();
